export const DEFAULT_ICON = 'fas fa-dice-d6';

export const ROUTE_MANAGEMENT = 'ROUTE_MANAGEMENT';
export const ROUTE_USERS = 'ROUTE_USERS';
export const ROUTE_PARTNERS = 'ROUTE_PARTNERS';
export const ROUTE_OPERATORS = 'ROUTE_OPERATORS';
export const ROUTE_TABLES = 'ROUTE_TABLES';
export const ROUTE_SOURCES = 'ROUTE_SOURCES';
export const ROUTE_PROXY = 'ROUTE_PROXY';
export const ROUTE_PROXY_DOMAINS = 'ROUTE_PROXY_DOMAINS';
export const ROUTE_PROXY_COUNTRY_USE = 'ROUTE_PROXY_COUNTRY_USE';
export const ROUTE_CURRENCIES = 'ROUTE_CURRENCIES';
export const ROUTE_CURRENCY_CONFIGS = 'ROUTE_CURRENCY_CONFIGS';
export const ROUTE_CONFIGS = 'ROUTE_CONFIGS';
export const ROUTE_FILES = 'ROUTE_FILES';
export const ROUTE_GAME_TYPES = 'ROUTE_GAME_TYPES';
export const ROUTE_AGGR_CONFIGS = 'ROUTE_AGGR_CONFIGS';
export const ROUTE_ENGINE_OPERATORS = 'ROUTE_ENGINE_OPERATORS';
export const ROUTE_AGGREGATOR = 'ROUTE_AGGREGATOR';
export const ROUTE_LIMITS = 'ROUTE_LIMITS';
export const ROUTE_DEALERS = 'ROUTE_DEALERS';
export const ROUTE_LOCALIZATION = 'ROUTE_LOCALIZATION';
export const ROUTE_TABLE_LIMITS = 'ROUTE_TABLE_LIMITS';
export const ROUTE_WAZDAN_FREESPINS = 'ROUTE_WAZDAN_FREESPINS';
export const ROUTE_TOMHORN_FREESPINS = 'ROUTE_TOMHORN_FREESPINS';
export const ROUTE_BGAMING_FREESPINS = 'ROUTE_BGAMING_FREESPINS';
export const ROUTE_ADMIN_CHAT = 'ROUTE_ADMIN_CHAT';
export const ROUTE_PROVIDER_GAMES = 'ROUTE_PROVIDER_GAMES';
export const ROUTE_PROVIDER_NAMES = 'ROUTE_PROVIDER_NAMES';
export const ROUTE_LIVE_VIDEOS = 'ROUTE_LIVE_VIDEOS';
export const ROUTE_LOGS = 'ROUTE_LOGS';

export const ROUTE_TO_ICON_MAP = {
    [ROUTE_MANAGEMENT]: 'fas fa-cogs',
    [ROUTE_USERS]: 'fas fa-users-cog',
    [ROUTE_PARTNERS]: 'fas fa-handshake',
    [ROUTE_OPERATORS]: 'fas fa-plug',
    [ROUTE_TABLES]: 'fas fa-dice-d6',
    [ROUTE_SOURCES]: 'fas fa-rocket',
    [ROUTE_PROXY]: 'fas fa-network-wired',
    [ROUTE_PROXY_DOMAINS]: 'fas fa-network-wired',
    [ROUTE_PROXY_COUNTRY_USE]: 'fas fa-network-wired',
    [ROUTE_CURRENCIES]: 'fas fa-money-bill',
    [ROUTE_CURRENCY_CONFIGS]: 'fas fa-money-bill',
    [ROUTE_CONFIGS]: 'fas fa-cogs',
    [ROUTE_FILES]: 'fas fa-server',
    [ROUTE_GAME_TYPES]: 'fas fa-chess',
    [ROUTE_AGGR_CONFIGS]: 'fas fa-chess',
    [ROUTE_ENGINE_OPERATORS]: 'fas fa-chess',
    [ROUTE_AGGREGATOR]: 'fas fa-server',
    [ROUTE_LIMITS]: 'fas fa-chess',
    [ROUTE_DEALERS]: 'fas fa-users',
    [ROUTE_LOCALIZATION]: 'fas fa-language',
    [ROUTE_TABLE_LIMITS]: 'fas fa-search',
    [ROUTE_ADMIN_CHAT]: 'fas fa-comment',
    [ROUTE_PROVIDER_GAMES]: 'fas fa-chess',
    [ROUTE_PROVIDER_NAMES]: 'fas fa-chess-board',
    [ROUTE_LIVE_VIDEOS]: 'fas fa-tv',
    [ROUTE_LOGS]: 'fas fa-file-alt',
}


export function getRouteIcon(route) {
    return ROUTE_TO_ICON_MAP[route] ?? DEFAULT_ICON;
}
